import { DateTime } from 'luxon';

import { EventSalesBreakdownTableInstance, EventSalesInventoryData } from './instance';
import { getEventTimeInfo, isEventDateInventory } from './utils';

const exportColumnsCreator = EventSalesBreakdownTableInstance.columnExportHelper;

const createEventDateColumns = () => [
  exportColumnsCreator.create({
    header: 'Event Date',
    cell: (row: EventSalesInventoryData) => {
      if (!isEventDateInventory(row)) return null;
      return DateTime.fromISO(row.event_date.starting_at).toLocaleString(DateTime.DATE_SHORT);
    },
  }),
  exportColumnsCreator.create({
    header: 'Event Time',
    cell: (row: EventSalesInventoryData) => {
      if (!isEventDateInventory(row)) return null;
      const { startingAt, endingAt, timezone } = getEventTimeInfo(row.event_date.starting_at);
      return `${startingAt} - ${endingAt} ${timezone}`;
    },
  }),
  exportColumnsCreator.create({
    header: 'Ticket Name',
    cell: (row: EventSalesInventoryData) => {
      if (!isEventDateInventory(row)) return null;
      return row.store_item.name;
    },
  }),
  exportColumnsCreator.create({
    header: 'Ticket Type',
    cell: (row: EventSalesInventoryData) => {
      if (!isEventDateInventory(row)) return null;
      return row.store_item.ticket_type;
    },
  }),
  exportColumnsCreator.create({
    header: 'Available',
    cell: (row: EventSalesInventoryData) => {
      if (!isEventDateInventory(row)) return null;
      return row.store_item.manage_inventory ? row.inventory?.current_available : 'Unlimited';
    },
  }),
  exportColumnsCreator.create({
    header: 'Sold',
    cell: (row: EventSalesInventoryData) => {
      if (!isEventDateInventory(row)) return null;
      return row.inventory?.total_sold;
    },
  }),
];

const createSeasonTicketColumns = () => [
  exportColumnsCreator.create({
    header: 'Ticket Name',
    cell: (row: EventSalesInventoryData) => {
      if (isEventDateInventory(row)) return null;
      return row.name;
    },
  }),
  exportColumnsCreator.create({
    header: 'Ticket Type',
    cell: (row: EventSalesInventoryData) => {
      if (isEventDateInventory(row)) return null;
      return row.ticket_type;
    },
  }),
  exportColumnsCreator.create({
    header: 'Available',
    cell: (row: EventSalesInventoryData) => {
      if (isEventDateInventory(row)) return null;
      return row.manage_inventory ? row.inventory_summary?.amount : 'Unlimited';
    },
  }),
  exportColumnsCreator.create({
    header: 'Sold',
    cell: (row: EventSalesInventoryData) => {
      if (isEventDateInventory(row)) return null;
      return row.inventory_summary?.count;
    },
  }),
];

const eventSalesBreakdownExportColumns = (breakdownType: 'event_dates' | 'season_tickets') => {
  return breakdownType === 'event_dates' ? createEventDateColumns() : createSeasonTicketColumns();
};

export { eventSalesBreakdownExportColumns };
